import { Theme, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function grid(theme: Theme) {
  return {
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.border': {
            '--Grid-borderWidth': '1px',
            borderTop: 'var(--Grid-borderWidth) solid',
            borderLeft: 'var(--Grid-borderWidth) solid',
            borderColor: theme.palette.divider,
            '& > div': {
              borderRight: 'var(--Grid-borderWidth) solid',
              borderBottom: 'var(--Grid-borderWidth) solid',
              borderColor: theme.palette.divider,
            },
          },
          '&.mBorder': {
            '--Grid-borderWidth': '1px',
            borderTop: 'var(--Grid-borderWidth) solid',
            // borderLeft: 'var(--Grid-borderWidth) solid',
            borderColor: theme.palette.divider,
            '& > div': {
              // borderRight: 'var(--Grid-borderWidth) solid',
              borderBottom: 'var(--Grid-borderWidth) solid',
              borderColor: theme.palette.divider,
            },
          }
        },
      },
    },
    MuiGrid2: {
      styleOverrides: {
        root: {
          '--Grid-borderWidth': '1px',
          borderTop: 'var(--Grid-borderWidth) solid',
          borderLeft: 'var(--Grid-borderWidth) solid',
          borderColor: theme.palette.divider,
          '& > div': {
            borderRight: 'var(--Grid-borderWidth) solid',
            borderBottom: 'var(--Grid-borderWidth) solid',
            borderColor: theme.palette.divider,
          },
        },
      },
    }
  };
}
